import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { colors } from "../config/colors";

const ToggleStyled = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    ...theme.typography.subtitle2,
  },
}));

const ActiveSwitch = styled(Switch)(() => ({
  "& .MuiSwitch-switchBase": {
    color: colors.disabled,
    "&.Mui-checked": {
      color: colors.primary,
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: colors.grayBackground,
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: colors.toggle,
  },
}));

export const ToggleButton = ({
  label = "",
  isChecked = false,
  onClick = null,
  disabled = false,
}) => {
  return (
    <ToggleStyled
      control={<ActiveSwitch />}
      checked={isChecked}
      onChange={disabled ? null : onClick}
      disabled={disabled}
      label={label}
    />
  );
};

ToggleButton.propTypes = {
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
